<template>
    <section class="">
        <section id="bbfooter" class="footer p-2 p-md-5">
            <div class="container">
            <div class="row" style="">
                <div class="col-12 col-md-6 text-center text-md-left mb-3">
                    <img src="../assets/images/Logo_Disi.png" width="150" />
                </div>
                <div class="col-12 col-md-6 ">
                    <div class="text-center text-md-left float-md-right">
                        <h4>
                            <mdb-icon icon="headset" />
                            <a href="tel:02423232300" class="text-white"> 0242 323 23 00</a>
                        </h4>
                        <p>Her gün 09:00 - 18:00 saatlerinde çağrı<br /> merkezimizden ulaşabilirsiniz</p>
                    </div>

                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-4" style="border-bottom: 1px solid #fff; height: 19px"></div>
                <div class="col-12 col-md-4 text-center my-3 pt-3 pt-md-0" >
                    <a :href="settings.facebook"><mdb-icon fab icon="facebook-f" class="social-footer" /> </a>
                    <a :href="settings.instagram"> <mdb-icon fab icon="instagram" class="social-footer" /> </a>
                    <a :href="settings.twitter"><mdb-icon fab icon="twitter" class="social-footer" /> </a>
                    <a :href="settings.youtube"><mdb-icon fab icon="youtube" class="social-footer" /> </a>
                </div>
                <div class="col-12 col-md-4" style="border-bottom: 1px solid #fff; height: 19px"></div>
            </div>
            <div class="row pt-3 pt-md-0">
                <div class="col-12 col-md-6">
                    <div class="row">
                        <div class="col-12 col-md-4 pb-3">
                            <h6>Kurumsal</h6>
                            <mdb-list-group v-for="(bbmenu, index) in biletbulmenu" :key="index" :action="true"
                                            :href="bbmenu.link" tag="a" class="text-white">
                                <div class="p-md-0 ">{{bbmenu.name}}</div>
                            </mdb-list-group>
                        </div>
                        <div class="col-12 col-md-4 pb-3">
                            <h6>Havayolları</h6>
                            <mdb-list-group v-for="(airline, index) in airlines" :key="index" :action="true" href="#" tag="a" class="text-white">
                                <div class="p-md-0 ">{{airline.name}}</div>
                            </mdb-list-group>
                        </div>
                        <div class="col-12 col-md-4 pb-3" style="border-right: 1px solid white">
                            <h6>Popüler Uçuşlar</h6>
                            <mdb-list-group v-for="(destination, index) in destinations" :key="index" :action="true" href="#" tag="a" class="text-white">
                                <div class="p-md-0 ">{{destination.name}}</div>
                            </mdb-list-group>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="row">
                        <div class="col-12 col-md-1" ></div>
                        <div class="col-12 col-md-6 pb-3">
                            <h6>Popüler Şehirler</h6>
                            <div class="row">
                                <div class="col-5">
                                    <mdb-list-group v-for="(city, index) in popCity.slice(0,6)" :key="index" :action="true" href="#" tag="a" class="text-white">
                                        <div class="p-md-0 ">{{city.name}}</div>
                                    </mdb-list-group>
                                </div>
                                <div class="col-6 pl-md-0">
                                    <mdb-list-group v-for="(city, index) in popCity.slice(6,12)" :key="index" :action="true" href="#" tag="a" class="text-white">
                                        <div class="p-md-0 ">{{city.name}}</div>
                                    </mdb-list-group>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-5 pl-md-0">
                            <h6>Popüler Ülkeler</h6>
                            <div class="row">
                                <div class="col-5">
                                    <mdb-list-group v-for="(county, index) in countries.slice(0,4)" :key="index" :action="true" href="#" tag="a" class="text-white">
                                        <div class="p-md-0 ">{{county.name}}</div>
                                    </mdb-list-group>
                                </div>
                                <div class="col-6 pl-md-0">
                                    <mdb-list-group v-for="(county, index) in countries.slice(4,8)" :key="index" :action="true" href="#" tag="a" class="text-white">
                                        <div class="p-md-0 ">{{county.name}}</div>
                                    </mdb-list-group>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mt-3 text-center">
                    <a href="https://www.tursab.org.tr/tr/ddsv" target="_blank">
                        <img src="../assets/images/tursab-dds-8127.png" style="padding-right: 6px">
                    </a>
                    <img src="../assets/images/IATA.png">
                    <p style="padding-top: 6px">2020 © Tüm hakları saklıdır.
                        biletbul.com</p>
                </div>

            </div>
        </div>
        </section>
        <section id="bottom-footer" class="bottom-footer d-none">
            <div class="container">
                <div class="row">
                    <div class="col-3">a</div>
                    <div class="col-5">b</div>
                    <div class="col-4">c</div>
                </div>
            </div>
        </section>
        <go-top bg-color="transparent" :src="require('../assets/images/ontop.png')" style="width: 61px;
    height: 68px;"></go-top>
    </section>

</template>

<script>
    import axios from "axios";
    import { mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption,mdbListGroup } from 'mdbvue';
    import GoTop from '@inotom/vue-go-top';
    export default {
        name: "bbfooter",
        components: {
            GoTop,
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbTabs,
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbBtn,
            mdbTextarea,
            mdbInput,
            mdbCarouselItem,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCarousel,
            mdbCarouselCaption,
            mdbListGroup

        },
        data: () => ({
            title:'Yurt Dışı En Uygun Uçak Biletleri',
            remoteUrl:'https://www.biletbul.com/biletbul/backend/public',
            icon:'chevron-right',
            currency : ['₺','$','€'],
            popCity: [],
            countries: [],
            airlines: [],
            destinations: [],
            biletbulmenu: [
                {
                    name:'Hakkımızda',
                    link:'/#/p/hakkimizda'
                },
                {
                    name:'Sıkça Sorulan Sorular',
                    link:'/#/sss'
                },

                {
                    name:'Kişisel Verilerin Korunması, Gizlilik Politikası ve Çerez (Cookie) Kullanımı İlkeleri',
                    link:'/#/gizlilik-sozlesmesi'
                },
                {
                    name:'İletişim',
                    link:'/#/iletisim'
                },

            ],
            settings: [],
        }),
        mounted() {

            axios.get("https://www.biletbul.com/backend/public/api/v1/popular/city",{
                headers: {

                }
            })
                .then(response => this.popCity=[...response.data.data]);

            axios.get("https://www.biletbul.com/backend/public/api/v1/popular/county",{
                headers: {

                }
            })
                .then(response => this.countries=[...response.data.data]);

            axios.get("https://www.biletbul.com/backend/public/api/v1/popular/airline",{
                headers: {

                }
            })
                .then(response => this.airlines=[...response.data.data]);

            axios.get("https://www.biletbul.com/backend/public/api/v1/popular/destination",{
                headers: {

                }
            })
                .then(response => this.destinations=[...response.data.data]);

            axios.get("https://www.biletbul.com/backend/public/api/v1/setting",{
                headers: {

                }
            })
                .then(response => this.settings=response.data.data);
        },
        watch: {
            settings: function () {
                localStorage.newsletter_agreement = this.settings.newsletter_agreement;
            }
        }
    }
</script>

<style scoped>
.vue-go-top {
    box-shadow: none!important;
}
</style>
